import type { ComponentProps } from 'react';
import { Link } from 'react-router-dom';

/**
 * Adapter für die Sidebar aus @elbklar/ui (`linkAs`): interne Pfade über
 * react-router, absolute Adressen (konto.elbklar.com) als normaler Link.
 */
export function RouterLink({ href, ...rest }: { href: string } & Omit<ComponentProps<typeof Link>, 'to'>) {
  if (/^https?:\/\//.test(href)) return <a href={href} {...rest} />;
  return <Link to={href} {...rest} />;
}
